import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Footer } from '@ahmdigital/ui';
import { useRouter } from 'next/router';
import React from 'react';
import ReactVisibilitySensor from 'react-visibility-sensor';

import determineFooterProps from './utils/determine-footer-props';
import footerActionCreators from '../../actions/footer';

type FooterProps = {
  actions: {
    footer: {
      setVisibility: (isVisible: any) => void;
    };
  };
};

const FooterWithStaticProps = ({ actions }: FooterProps) => {
  const { asPath } = useRouter();
  const props = determineFooterProps(asPath);

  return (
    <ReactVisibilitySensor
      intervalCheck={false}
      onChange={(value) => actions.footer.setVisibility(value)}
      partialVisibility
      scrollCheck
      scrollDelay={50}
    >
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ acknowledgement: { description: string; image: string; }; appCalloutIcons?: { [key: string]: { image: string; link: string; }; } | undefined; awards: { blurb: string; images: { alt: string; imageSrc: string; label: string; to: string; }[]; }; contacts: { ...; }[]; disclaimer: string; logo: { ...; }; navLinks: NavL...' is not assignable to type 'Partial<Pick<Pick<FooterProps, keyof FooterProps> & Pick<InferProps<{ appCalloutIcons: Requireable<InferProps<{ android: Validator<NonNullable<InferProps<{ image: Requireable<string>; link: Requireable<string>; }>>>; ios: Requireable<...>; }>>; navLinks: Validator<...>; }>, never> & Pick<...>, "className" | ... 1 mo...'. */}
      <Footer {...props} />
    </ReactVisibilitySensor>
  );
};

const mapDispatchToProps = (dispatch?: any) => ({
  actions: {
    footer: bindActionCreators(footerActionCreators, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(FooterWithStaticProps);

export { FooterWithStaticProps, mapDispatchToProps };
